import React from 'react';
import styled from 'styled-components';
import { body2 } from '@westwing/ui-kit/typography';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import BellaHybridLink from 'Client/components/Generic/Links/BellaHybridLink';
import FooterLinksAccordion from '../common/FooterLinksAccordion';
import { FooterLinks } from 'OneWestwingFooter/types';
import { FooterCountrySelector } from 'OneWestwingFooter/FooterCountrySelector';
import { FooterSeoLinks } from 'OneWestwingFooter/FooterSeoLinks';
import { OneWestwingFooterIds } from 'Common/qaIds';

const MobileComponent = styled.nav`
    display: block;

    ${forDesktop`
        display: none;
    `}
`;

const StyledFooterLink = styled(BellaHybridLink)`
    ${body2}
    color: ${({ theme }) => theme.colors.charcoal100};
    display: block;
    text-decoration: none;
    margin-bottom: 8px;
    box-sizing: border-box;
`;

const FooterSeoLinksMobile = styled.div`
    display: block;
    ${forDesktop`
        display: none;
    `}
`;

const FooterUsefulLinksMobile = ({
    track,
    footerLinks,
    isClub = false,
    hasSeoLinks = false,
}: {
    track: (trackingAction?: string) => void;
    footerLinks: FooterLinks[];
    isClub?: boolean;
    hasSeoLinks?: boolean;
}) => (
    <MobileComponent>
        {footerLinks.map(linksColumn => (
            <FooterLinksAccordion
                key={linksColumn.key}
                track={track}
                title={linksColumn.title}
                accordionTrackingActions={linksColumn.accordionTrackingActions}
            >
                <ul aria-label={linksColumn.title}>
                    {linksColumn.items.map((item, itemIndex) => (
                        <li key={`footer_${item.to ?? `${linksColumn.title}_${itemIndex}`}`}>
                            {item.to ? (
                                <StyledFooterLink
                                    target={item.openInNewTab ? '_blank' : '_self'}
                                    to={item.to}
                                    onClick={() => track(item.trackingAction)}
                                >
                                    {item.content}
                                </StyledFooterLink>
                            ) : (
                                // In this case tracking will not happen
                                item.content
                            )}
                        </li>
                    ))}
                </ul>
            </FooterLinksAccordion>
        ))}
        {isClub && hasSeoLinks && (
            <FooterSeoLinksMobile>
                <FooterSeoLinks />
            </FooterSeoLinksMobile>
        )}
        <div data-testid={OneWestwingFooterIds.owwCountrySelectorMobile}>
            <FooterCountrySelector testId={OneWestwingFooterIds.owwCountrySelectorOverlayMobile} isClub={isClub} />
        </div>
    </MobileComponent>
);

export default FooterUsefulLinksMobile;
